import React, { useContext, useState } from 'react'
import ReactTooltip from "react-tooltip";
import axios from 'axios'
import { GlobalContext } from '../../Context/GlobalContext';


const CaptionDownload = ({file, translations, setPopup}) => {
    const {ownerOfVODId} = useContext(GlobalContext)
   
   const downloadCaption = () => {
    if(translations?.length>0){
      setPopup({popup:true})
    } else {
        axios.post(`
        https://imd0mxanj2.execute-api.us-west-2.amazonaws.com/upload/get-captions`, {
          file:{_id: file._id},
          user:{_id:ownerOfVODId}
        })
        .then(res => {
            if(res.data) {
              axios({
                  url: res.data.response.payload, //your url
                  method: "GET",
                  responseType: "blob", // important
                })
                .then(response => {
                  const url = window.URL.createObjectURL(new Blob([response.data]));
                  const link = document.createElement("a");
                  link.href = url;
                  //or any other extension
                  link.setAttribute("download", `${file.metadata.filename}.vtt`); 
                  document.body.appendChild(link);
                  link.click();
                });
            }
         
        });
    }
  }
  return (
    <>
    <div
      className="share-item"
      onClick={downloadCaption}
      data-tip
      data-for="captionDownload"
    >
     <i class=" fas text-white fa-solid fa-closed-captioning"></i>
    </div>
    <ReactTooltip
        id="captionDownload"
        type="dark"
        place='top'
        effect="solid"
      >
        <span>{'Download Captions'}</span>
      </ReactTooltip>
      
    </>
  )
}

export default CaptionDownload